import { Alert, Platform } from "react-native";

type ConfirmarAcaoOptions = {
  titulo: string;
  mensagem: string;
  onConfirmar: () => void;
  destructive?: boolean;
  textoConfirmar?: string;
  textoCancelar?: string;
};

export function confirmarAcaoWebOuNativo({
  titulo,
  mensagem,
  onConfirmar,
  destructive = false,
  textoConfirmar = "Confirmar",
  textoCancelar = "Cancelar",
}: ConfirmarAcaoOptions) {
  if (Platform.OS === "web") {
    const confirmar = globalThis.confirm?.(`${titulo}\n\n${mensagem}`) ?? false;
    if (confirmar) onConfirmar();
    return;
  }

  Alert.alert(titulo, mensagem, [
    { text: textoCancelar, style: "cancel" },
    {
      text: textoConfirmar,
      style: destructive ? "destructive" : "default",
      onPress: onConfirmar,
    },
  ]);
}
